<template>
	<HackleProvider :instance="instance" :user="hackleUserInfo">
		<slot />
	</HackleProvider>
</template>

<script>
import { mapGetters } from 'vuex';
import { HackleProvider, createInstance } from '@comento/hackle-sdk';
import { IS_PRODUCTION } from '@/constants';

const instance = createInstance(
	IS_PRODUCTION ? import.meta.env.VITE_HACKLE_API_KEY_PROD : import.meta.env.VITE_HACKLE_API_KEY_DEV,
	{ debug: !IS_PRODUCTION },
);

export default {
	name: 'HackleLayoutProvider',
	computed: {
		...mapGetters(['userNo']),
		instance() {
			return instance;
		},
		hackleUserInfo() {
			return {
				userId: this.userNo,
			};
		},
	},
	components: {
		HackleProvider,
	},
};
</script>

<style lang="scss" scoped></style>
